import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SetupOnboardingComponent } from './components/setup-onboarding/setup-onboarding.component';
import { authGuard } from './guards/auth.guard';
import { LoginComponent } from './pages/login/login.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { OnboardingComponent } from './pages/onboarding/onboarding.component';
import { SidePanelComponent } from './pages/side-panel/side-panel.component';
import { InformativePageComponent } from './pages/informative-page/informative-page.component';

const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'todo', component: InformativePageComponent },
  {
    path: 'folder',
    children: [
      {
        path: '**',
        component: InformativePageComponent,
      },
    ],
  },
  {
    path: 'verified',
    component: InformativePageComponent,
  },
  {
    path: 'search',
    component: InformativePageComponent,
  },
  {
    path: 'side-panel',
    component: SidePanelComponent,
    canActivate: [authGuard],
  },
  {
    path: 'settings',
    component: InformativePageComponent,
  },
  {
    path: 'onboarding',
    component: OnboardingComponent,
  },
  {
    path: 'onboarding/start',
    component: SetupOnboardingComponent,
  },
  {
    path: '404',
    component: NotFoundComponent,
  },
  { path: '**', redirectTo: '/404' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      bindToComponentInputs: true,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
